<app-spinner></app-spinner>

<div class="mx-auto" style="width: 82%">

  <h1 *ngIf="!this.recreateindexsuccess && this.recreateindexsuccess !== undefined" class="text-center" style="color: red">Fehler beim neuerstellen des kompletten Suchindex</h1>
  <h1 *ngIf="this.recreateindexsuccess" class="text-center" style="color: green">Alle Suchindexe neu erstellt</h1>

  <a routerLink="/admin/jobform/create/">
    <button type="button" class="btn btn-primary mb-5">Job Erstellen</button>
  </a>

  <a class="ms-2" (click)="this.recreateIndex()">
    <button type="button" class="btn btn-warning mb-5">Alle Suchindexe neu erstellen</button>
  </a>

  <table class="table top">
    <thead>
    <tr>
      <th scope="col" class="pointer" (click)="this.sortTablebyColum('uuid')">
        UUID    <i *ngIf="this.lastsort === 'uuid'"
                   [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                   class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('title')">
        Title    <i *ngIf="this.lastsort === 'title'"
                    [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
                    class="bi"></i>
      </th>

      <th scope="col" class="pointer" (click)="this.sortTablebyColum('published')">Veröffentlicht
        <i *ngIf="this.lastsort === 'published'"
           [ngClass]="{'bi-arrow-up': this.lastsorttype === 'DESC', 'bi-arrow-down': this.lastsorttype === 'ASC'}"
           class="bi"></i>
      </th>

      <th>Aktionen</th>
    </tr>
    </thead>
    <tbody>
    <tr (click)="Helper.TableSelect($event)" *ngFor="let job of this.jobs | async" id="{{job.uuid}}">
      <td>{{ job.uuid }}</td>
      <td>{{ job.title }}</td>
      <td>
        <input type="checkbox" name="" id="checkbox{{job.uuid}}"
               [disabled]="!PermissionsHelper.hasPermission('staff.job.edit')" class="checkbox-slider"
               (click)="this.changePublishedStatus($event,job.uuid)" [checked]="job.published">
        <label for="checkbox{{job.uuid}}"></label>
      </td>
      <td>
        <button class="btn btn-primary me-2" [disabled]="!PermissionsHelper.hasPermission('staff.job.edit')"
                (click)="this.router.navigateByUrl('/admin/jobform/edit/' + job.uuid)">Job Bearbeiten
        </button>
        <button class="btn btn-danger me-2" (click)="this.router.navigateByUrl('/admin/jobform/delete/' + job.uuid)"
                [disabled]="!PermissionsHelper.hasPermission('staff.job.delete')">Job Löschen
        </button>
        <button class="btn btn-warning" (click)="this.recreateIndex(job.uuid)"
                [disabled]="!PermissionsHelper.hasPermission('staff.index.renew')">Suchindex neu erstellen
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
